export type AnalyticsParams = Record<string, unknown>;

type AnalyticsWindow = Window &
  typeof globalThis & {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  };

export function buildAnalyticsParams(
  params: AnalyticsParams,
  { debugMode = false }: { debugMode?: boolean } = {}
): AnalyticsParams {
  return debugMode ? { ...params, debug_mode: true } : params;
}

export function ensureAnalyticsQueue(target: AnalyticsWindow) {
  target.dataLayer = target.dataLayer || [];

  if (typeof target.gtag !== "function") {
    target.gtag = (...args: unknown[]) => {
      target.dataLayer!.push(args);
    };
  }

  return target.gtag;
}

export function dispatchAnalyticsEvent(
  name: string,
  params: AnalyticsParams,
  target: AnalyticsWindow
) {
  const gtag = ensureAnalyticsQueue(target);
  gtag("event", name, params);
}

export function trackEvent(name: string, params: AnalyticsParams = {}) {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  if (typeof window === "undefined") {
    return;
  }

  dispatchAnalyticsEvent(
    name,
    buildAnalyticsParams(params, {
      debugMode: window.location.hostname === "staging.graphify.homes",
    }),
    window as AnalyticsWindow
  );
}
